module.exports = require('react');


/** WEBPACK FOOTER **
 ** ./src/React.js
 **/